import { CSSProperties } from 'react';
import styled from 'styled-components';

import { color, dimension } from '@creditornot/cb-ingredients/design-tokens';

const StyledHr = styled.hr`
  background-color: ${color.border};
  border: none;
  flex-shrink: 0;
  height: ${dimension.borderWidthRegularMedium};
  margin: 0;
`;

type Props = {
  className?: string;
  style?: CSSProperties;
};

export function Divider({ className, style }: Props) {
  return <StyledHr style={style} className={className} />;
}
